module.exports = __webpack_public_path__ + "static/media/sample3.c1af5fa1.jpg";